import { createContext } from 'react'

import { CurrencyAreaOutputDto, CurrencyEnum } from '../../../lib/graphql'
import { multiplyByFactor } from '../../../utils/prices'

export interface CurrencyAreaContext {
  currencyArea: CurrencyAreaOutputDto
}

export const CurrencyAreaContext = createContext<CurrencyAreaContext>({
  // TODO - Maybe replace currencyArea default value by null to catch errors
  currencyArea: {
    currency: CurrencyEnum.EUR,
    vatRates: [
      0,
      multiplyByFactor(5.5),
      multiplyByFactor(10),
      multiplyByFactor(20),
    ],
    multiVatRates: [[multiplyByFactor(10), multiplyByFactor(20)]],
  },
})
